import React from "react";
import Select from "react-select";
import Grid from "@material-ui/core/Grid";
import Header from "../../components/Header";
import RadioItem from "../../components/RadioItem";
import AddUserModal from "../../components/AddUserModal";
import EditSuperAdminModal from "../../components/EditSuperAdminModal";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";
import Firebase from "../../firebasehelper";
import { admin_types } from "../../Constants/selections";
import "./index.css";
import { updateRetailerAdminLead, resetPassword } from "../../api/UserApi";

class BrandAdmins extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: false,
      agencies: [],
      brand_name: "",
      brand_url: "",
      tab: "Community Members",
      searchKey: "",
      searchStatus: "",
      commericalUserId: null,
      selectedAdminTypes: {},
      radioSelected: {},
    };
  }
  // used for filtering admins by type and restricting the dropdown for non super admins
  restrictedAdminTypes = {
    "Sales manager": ["Sales manager", "Sales rep"],
    "Service manager": ["Service manager", "Service rep"],
  };

  ADMIN_TYPES = admin_types
    .map((type) => ({
      value: type,
      label: type,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username, agencyData } = this.props.location.state;
      this.setState({ username, role, brand, agencyData, loading: true });

      const filters = this.restrictedAdminTypes[agencyData.type];
      if (filters)
        this.ADMIN_TYPES = this.ADMIN_TYPES.filter((valueObj) =>
          filters.includes(valueObj.value)
        );

      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          white: res.white,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          commericalUserId: res.commericalUserId,
          is_ecochat_need: res.is_ecochat_need,
        });
      });
      Firebase.getAgencyByBrandID(brand, (res) => {
        res.sort((prev, next) => prev.username.localeCompare(next.username));

        const adminObj = res.reduce((acc, cur) => {
          const value = cur.type ? { label: cur.type, value: cur.type } : null;
          acc[cur.uid] = value;
          return acc;
        }, {});

        const radioObj = res.reduce((acc, cur) => {
          const value = {
            ecoChat: cur.ecoChat ? cur.ecoChat : false,
            emailNotification: cur.emailNotification
              ? cur.emailNotification
              : false,
          };
          acc[cur.uid] = value;
          return acc;
        }, {});

        this.setState({
          radioSelected: radioObj,
          selectedAdminTypes: adminObj,
          agencies: this.filterAdminsToDisplay(agencyData, res),
        });
      });
    }
  }
  editBrandAdmin = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };
  onEditUser = (username, email) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      Firebase.updateAgencyData(selectedUser.uid, {
        username,
        email,
      });

      updateRetailerAdminLead(selectedUser.uid, email);
    }
  };
  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };
  addUser = (username, email, password, value = null) => {
    const { brand } = this.state;
    Firebase.addAgency(email, password)
      .then((uid) => {
        let data = {
          uid: uid,
          username,
          email,
          role: 2,
          brand: brand,
          approved: true,
        };
        // this is used to add brand admins with a value for admin type {label: string, value: string}
        if (value) {
          data.type = value.value;
        }
        Firebase.writeAgencydata(uid, data);
      })
      .catch((err) => {
        alert(err);
      });
  };
  setCommercialUser = (uid) => {
    const { brand } = this.state;
    Firebase.updateBrandDataById(brand, {
      commericalUserId: uid,
    });
  };
  handleChangeChecked = (item, { target }) => {
    const { uid } = item;
    if (target.name === "commercial_right") {
      if (target.checked) this.setCommercialUser(uid);
      else this.setCommercialUser(null);
    } else {
      Firebase.updateAgencyData(uid, {
        [target.name]: target.checked,
      });
    }

    this.setState({ [target.name]: target.checked });
  };
  handleEmailNotification = async (item, value) => {
    if (item.emailNotification !== value) {
      await Firebase.updateAgencyData(item.uid, { emailNotification: value });
    }
  };
  handleEcoChat = async (item, value) => {
    if (item.ecoChat !== value) {
      await Firebase.updateAgencyData(item.uid, { ecoChat: value });
    }
  };
  handleChangeAdminType = async (item, value) => {
    Firebase.writeAgencydata(item.uid, {
      ...item,
      type: value.value,
    });
    this.setState((prevState) => ({
      ...prevState,
      selectedAdminTypes: {
        ...prevState.selectedAdminTypes,
        [item.uid]: value,
      },
    }));
  };
  filterAdminsToDisplay = (agencyData, agencies) => {
    // if Super admin or if on admin.ecosystem.co.uk, return all admins
    if (
      agencyData.role === 0 ||
      (agencyData.type && agencyData.type === "Super admin")
    )
      return agencies;

    const filters = this.restrictedAdminTypes[agencyData.type];

    // if not Sales manger, Service manager nor Super admin, don't show any admins (just in case)
    if (!filters) return [];
    else return agencies.filter((admin) => filters.includes(admin.type));
  };
  render() {
    const {
      username,
      role,
      logo,
      agencies,
      brand,
      brand_name,
      is_property_brand,
      selectedUser,
      commericalUserId,
      white,
      hex,
      selectedAdminTypes,
      radioSelected,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="home-content">
            <div className="user-content">
              <button
                type="button"
                className="btn btn-brand-hex btn-white"
                data-toggle="modal"
                data-target="#add_user"
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                  marginTop: 20,
                  marginBottom: 20,
                }}
              >
                Add an admin
              </button>
              <div className="brand-admin-table-header">
                <Grid
                  container
                  spacing={1}
                  style={{ justifyContent: "space-between" }}
                >
                  <Grid item className="grid-item grid-item__name-header">
                    <div className="brand-admin-row name-container">Name</div>
                  </Grid>
                  <Grid
                    item
                    className="grid-item grid-item__notifications-header"
                  >
                    <div className="brand-admin-row commercial-rights-container">
                      Email Notifications
                    </div>
                  </Grid>
                  <Grid item className="grid-item grid-item__chat-header">
                    <div className="brand-admin-row ecochat-support-rights-container">
                      User chat
                    </div>
                  </Grid>
                  <Grid item className="grid-item grid-item__type-header">
                    <div className="brand-admin-row type-container">Type</div>
                  </Grid>
                  {/* the grid item below is a placeholder to align justify-content: space-between header with rows  */}
                  <Grid item className="grid-item grid-item__actions">
                    <div className="brand-admin-row actions-container"></div>
                  </Grid>
                </Grid>
              </div>
              {agencies.map((item, i) => {
                const commercial_rights_checked = item.uid === commericalUserId;
                const support_right_checked = item.support_right || false;
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                    key={i}
                  >
                    <Grid
                      container
                      spacing={1}
                      style={{ justifyContent: "space-between" }}
                    >
                      <Grid item className="grid-item grid-item__name">
                        <div className="brand-admin-row name-container">
                          <p style={{ marginBottom: 0 }}>{item.username}</p>
                        </div>
                      </Grid>
                      <Grid item className="grid-item grid-item__notifications">
                        <div className="brand-admin-row commercial-rights-container">
                          <RadioItem
                            menuName=""
                            checked={radioSelected[item.uid].emailNotification}
                            onYes={() => {
                              this.handleEmailNotification(item, true);
                            }}
                            onNo={() => {
                              this.handleEmailNotification(item, false);
                            }}
                          />
                          {/* <Checkbox
                            checked={commercial_rights_checked}
                            onChange={(e) => this.handleChangeChecked(item, e)}
                            name="commercial_right"
                            color="primary"
                          /> */}
                        </div>
                      </Grid>
                      <Grid item className="grid-item grid-item__chat">
                        <div className="brand-admin-row ecochat-support-rights-container">
                          {/* <p>{is_ecochat_need ? "Yes" : "No"}</p> */}
                          <RadioItem
                            menuName=""
                            checked={radioSelected[item.uid].ecoChat}
                            onYes={() => {
                              this.handleEcoChat(item, true);
                            }}
                            onNo={() => {
                              this.handleEcoChat(item, false);
                            }}
                          />
                          {/* <Checkbox
                            checked={support_right_checked}
                            onChange={(e) => this.handleChangeChecked(item, e)}
                            name="support_right"
                            color="primary"
                          /> */}
                        </div>
                      </Grid>
                      <Grid item className="grid-item grid-item__type">
                        <div className="brand-admin-row type-container">
                          <Select
                            inputProps={{
                              autoComplete: "random-string",
                              autofill: "off",
                            }}
                            placeholder="Type"
                            className="select"
                            value={selectedAdminTypes[item.uid]}
                            onChange={(value) =>
                              this.handleChangeAdminType(item, value)
                            }
                            options={this.ADMIN_TYPES}
                          />
                        </div>
                      </Grid>
                      <Grid item className="grid-item grid-item__actions">
                        <div className="brand-admin-row actions-container">
                          <button
                            type="button"
                            className="btn btn-brand-hex btn-white"
                            style={{
                              "--hover-text-color": white ? "white" : "black",
                              "--hover-color": hex,
                              backgroundColor: "white",
                              color: "black",
                              margin: 0,
                            }}
                            data-toggle="modal"
                            data-target="#edit_super_admin"
                            onClick={this.editBrandAdmin(item)}
                          >
                            View/Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-green"
                            style={{ margin: 0 }}
                            data-toggle="modal"
                            data-target="#reset_password_super_admin"
                            onClick={this.editBrandAdmin(item)}
                          >
                            Reset password
                          </button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </div>
          </div>
        </main>
        <AddUserModal
          addUser={(username, email, password, value) =>
            this.addUser(username, email, password, value)
          }
          adminOptions={this.ADMIN_TYPES}
          hex={hex}
          white={white}
        />
        <EditSuperAdminModal
          onSave={this.onEditUser}
          initialValues={selectedUser}
          hex={hex}
          white={white}
        />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
          hex={hex}
          white={white}
        />
      </div>
    );
  }
}
export default BrandAdmins;



// WEBPACK FOOTER //
// ./src/screens/BrandAdmins/index.js